import { Box, Stack, styled } from '@mui/material';
export var StyledHeaderRow = styled(Stack)(function (_a) {
    var theme = _a.theme;
    return ({
        backgroundColor: theme.palette.grey[400],
        padding: '4px 16px',
        border: "1px solid ".concat(theme.palette.divider),
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
    });
});
export var StyledPeriodList = styled(Stack)(function (_a) {
    var theme = _a.theme;
    return ({
        maxHeight: '16rem',
        overflow: 'auto',
        borderWidth: '0 1px 1px 1px',
        borderStyle: 'solid',
        borderColor: theme.palette.divider,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
    });
});
export var StyledPeriodRow = styled(Stack)(function (_a) {
    var theme = _a.theme;
    return ({
        borderBottom: "1px solid ".concat(theme.palette.divider),
        cursor: 'pointer',
        flexDirection: 'row',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
        },
    });
});
export var StyledCell = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        borderRight: "1px solid ".concat(theme.palette.divider),
        '&:last-child': {
            borderRight: 'none',
        },
    });
});
